import { compareDesc, isSameYear } from "date-fns";

import { isNil } from "lodash";
import { type Chart } from "../components/Charts/props";

export enum DateFormats {
    MMyy = "MM/yy",
    Myy = "M/yy",
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Allow this format
    MMM_yyyy = "MMM yyyy",
    MMM = "MMM",
}

export function sortByDate<T extends { date: Date }>(data: T[]): T[] {
    return data.sort((a, b) => compareDesc(new Date(a.date), new Date(b.date)));
}

export function sortByNullableDate<T extends { date: Date | null | undefined }>(data: T[]): T[] {
    return data
        .map((item, index) => ({ item, index }))
        .sort(({ item: a, index: indexA }, { item: b, index: indexB }) => {
            if (isNil(a.date) && isNil(b.date)) {
                // both null/undefined → keep original order of the items
                return indexA - indexB;
            }

            if (isNil(a.date)) return -1; // null/undefined first
            if (isNil(b.date)) return 1;

            return compareDesc(new Date(a.date), new Date(b.date));
        })
        .map(({ item }) => item);
}

export const dateTimeFormat = new Intl.DateTimeFormat("cs-CZ", {
    timeZone: "Europe/Prague",
});

export const getXAxisLabelFormats = (data: Chart[], isDesktop: boolean): DateFormats => {
    const firstDate = data[0].data[0].date;
    const lastDate = data[0].data[data[0].data.length - 1].date;
    if (!isSameYear(firstDate, lastDate)) return isDesktop ? DateFormats.MMM_yyyy : DateFormats.Myy;
    return DateFormats.MMM;
};
